import React from 'react';
import PropTypes from 'prop-types';

import get from 'lodash/get';

import Button from 'wonderbly-components/lib/Button';
import AmazonWidget from './AmazonWidget';

import Loading from '../../Loading';
import Amazon from '../../Checkout/Amazon/Amazon';
import linkFactory from '../../../../analytics/factory/link';
import UserForm from '../../UserForm';

import './AmazonCheckout.scss';

const AmazonCheckout = props => {
  if (!props.amazonSettings) {
    // Meaning Amazon public keys weren't fetched from Eagle yet. These are needed to initialize the widget.
    // Return spinner.
    return <Loading relative dark small />;
  }

  if (!props.amazonAuthentication) {
    // This loads an Amazon Pay SDK. Once that is done, the Amazon component will try to log-in the user thanks to the 'autoLogin' prop.
    // ATTENTION - this will trigger a popup. Remove this setting if this is not appropriate.
    // The reason for this behaviour - the user should already be authenticated with Amazon once they reach this page.
    const amazonDetails = {
      widgetUrl: props.widgetUrl,
      clientId: props.clientId,
      merchantId: props.merchantId,
    };

    return (
      <section className="quick-checkout">
        <Amazon amazonDetails={amazonDetails}
          handleAuthComplete={props.setAmazonAuthentication}
          onClick={linkFactory({
            category: 'Cart',
            action: 'Pay With Amazon',
            label: 'Amazon Pay',
          })}
          autoLogin
        />
      </section>
    );
  }

  // If we are here - it means that widget is loaded and user has authenticated. We can now render the wallet and address widgets.
  return (
    <div className="amazon-widget__container">
      <AmazonWidget
        {...props}
        widgetType="address"
      />

      <AmazonWidget
        {...props}
        widgetType="custom"
        isHidden={!props.amazonAuthentication || !props.addressPreviouslySubmitted}>
        <UserForm form={props.shippingMethodsForm} className="amazon-widget__user-form" />
      </AmazonWidget>

      <AmazonWidget
        {...props}
        widgetType="wallet"
        isHidden={parseInt(get(props, 'total.amount'), 10) === 0}
      />
      <AmazonWidget widgetType="custom" {...props}>
        <Button
          className="button--amazon"
          colour="green"
          onClick={props.handlePaymentConfirmation}
          raised
          fullWidth
          disabled={props.disabled || !props.orderReference || props.isSubmitting} >
          { props.cta || 'Amazon Pay' }
        </Button>
      </AmazonWidget>

      {props.isSubmitting &&
        <Loading className="amazon-widget--submitting" absolute small dark/>
      }
    </div>
  );
};

AmazonCheckout.propTypes = {
  shippingMethodsForm: PropTypes.object.isRequired,
  handleAddressSelection: PropTypes.func.isRequired,
  handleOptInClick: PropTypes.func.isRequired,
  handlePaymentConfirmation: PropTypes.func.isRequired,
  setAmazonAuthentication: PropTypes.func.isRequired,
  clientId: PropTypes.string,
  cta: PropTypes.string,
  marketingOptInLabel: PropTypes.string,
  merchantId: PropTypes.string,
  orderReference: PropTypes.string,
  widgetUrl: PropTypes.string,
  addressPreviouslySubmitted: PropTypes.bool,
  disabled: PropTypes.bool,
  fetchingShippingMethods: PropTypes.bool,
  isSandbox: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  amazonAuthentication: PropTypes.object,
  amazonSettings: PropTypes.object,
  total: PropTypes.shape({
    amount: PropTypes.string
  }).isRequired,
  isOptInChecked: PropTypes.oneOf([null, true, false])
};

export default AmazonCheckout;



// WEBPACK FOOTER //
// ./src/client/js/view/components/PaymentMethods/Amazon/AmazonCheckout.js